// Configuración dinámica de baseURL según el entorno (Local en Laragon vs Producción)
const isLocalhost = Boolean(
    typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.endsWith('.test')
    )
);

const baseURL = process.env.REACT_APP_API_URL || (
    isLocalhost
        ? 'http://localhost/dxntingomaria/public'
        : (typeof window !== 'undefined' ? window.location.origin : 'https://dxntingomaria.com')
);

export default baseURL;
